// Static Sticky Cards (ES Module)
// Uses global gsap, ScrollTrigger, and Lenis from window object

document.addEventListener("DOMContentLoaded", () => {
     if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
          console.warn('⚠️ Sticky Cards Static: GSAP or ScrollTrigger not loaded');
          return;
     }
     
     gsap.registerPlugin(ScrollTrigger);

     const lenis = new Lenis();
     lenis.on("scroll", ScrollTrigger.update);
     gsap.ticker.add((time) => {
          lenis.raf(time * 1000);
     });
     gsap.ticker.lagSmoothing(0);

     const stickyCards = document.querySelectorAll(".sticky-card");

     stickyCards.forEach((card, index) => {
          if (index < stickyCards.length - 1) {
               ScrollTrigger.create({
                    trigger: card,
                    start: "top top",
                    endTrigger: stickyCards[stickyCards.length - 1],
                    end: "top top",
                    pin: true,
                    pinSpacing: false,
               });
          }

          if (index < stickyCards.length - 1) {
               ScrollTrigger.create({
                    trigger: stickyCards[index + 1],
                    start: "top bottom",
                    end: "top top",
                    onUpdate: (self) => {
                         const progress = self.progress;
                         const scale = 1 - progress * 0.25;
                         const rotation = (index % 2 === 0 ? 5 : -5) * progress;
                         const afterOpacity = progress;

                         gsap.set(card, {
                              scale: scale,
                              rotation: rotation,
                              "--after-opacity": afterOpacity,
                         });
                    },
               });
          }
     });

     // La Collection Lightbox
     const mosaic = document.querySelector('#card-1 .collection-mosaic');
     const overlay = document.getElementById('collection-lightbox');
     const content = overlay ? overlay.querySelector('.collection-lightbox-content') : null;

     if (mosaic && overlay && content) {
          mosaic.addEventListener('click', (e) => {
               const img = e.target.closest('img');
               if (!img) return;
               overlay.classList.add('open');
               content.innerHTML = '';
               const large = document.createElement('img');
               large.src = img.currentSrc || img.src;
               large.alt = img.alt || '';
               content.appendChild(large);
               overlay.setAttribute('aria-hidden', 'false');
          });

          overlay.addEventListener('click', (e) => {
               if (e.target === overlay || e.target === content) {
                    overlay.classList.remove('open');
                    overlay.setAttribute('aria-hidden', 'true');
                    content.innerHTML = '';
               }
          });

          document.addEventListener('keydown', (e) => {
               const activeElement = document.activeElement;
               if (activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA' || activeElement.tagName === 'SELECT' || activeElement.contentEditable === 'true')) {
                    return;
               }

               if (e.key === 'Escape' && overlay.classList.contains('open')) {
                    overlay.classList.remove('open');
                    overlay.setAttribute('aria-hidden', 'true');
                    content.innerHTML = '';
               }
          });
     }
     
     console.log('✅ Sticky Cards Static initialized');
});

export default {};
